module.exports = __webpack_public_path__ + "img/modular_settlement_pick up@2x.578a2ed3.png";